<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 34 34">
    <circle cx="16" cy="16" r="15.9155" class="progress-bar__background" />
    <circle
      cx="16"
      cy="16"
      r="15.9155"
      class="progress-bar__progress js-progress-bar"
      :style="`stroke-dashoffset: ${offsetValue}`"
    />
    <text
      x="50%"
      y="50%"
      dominant-baseline="mathematical"
      text-anchor="middle"
      class="fill-current"
      font-size="10px"
      font-weight="800"
    >
      {{ completionPercentage }}%
    </text>
  </svg>
</template>
<script>
export default {
  name: 'CircleProgressBar',
  props: {
    completionPercentage: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  computed: {
    offsetValue() {
      return `${300 - this.completionPercentage}px`;
    },
  },
};
</script>
<style lang="scss" scoped>
$progress-bar-stroke-width: 1.8;
$progress-bar-size: 100px;

svg {
  height: $progress-bar-size;
  // transform: rotate(-90deg);
  width: $progress-bar-size;
}

.progress-bar__background {
  fill: none;
  stroke: #fff;
  stroke-width: $progress-bar-stroke-width;
}

.progress-bar__progress {
  fill: none;
  stroke: #fff;
  stroke: #00afcb;
  stroke-dasharray: 100 100;
  stroke-dashoffset: 100;
  stroke-linecap: round;
  stroke-width: $progress-bar-stroke-width;
  transition: stroke-dashoffset 1s ease-in-out;
}
</style>
